import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";

class Design3 extends Component {
  render() {
    return (
      <section className="landing-section landing-split landing-muted" id="manager">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="landing-image-frame">
                <img className="img-fluid" src="assets/img/manager/manager.png" alt="Administration scolaire" />
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <span className="landing-eyebrow">Administration</span>
              <h2>Des décisions plus rapides avec des données mieux organisées.</h2>
              <p className="landing-lead">
                EviveSoma aide les responsables à suivre les activités, les ressources, les paiements et les résultats
                sans multiplier les fichiers dispersés.
              </p>

              <div className="landing-check-list">
                <div>
                  <FeatherIcon icon="bar-chart-2" size={19} />
                  <span>Statistiques utiles sur les élèves, classes et opérations scolaires.</span>
                </div>
                <div>
                  <FeatherIcon icon="archive" size={19} />
                  <span>Archivage des dossiers et historique consultable à tout moment.</span>
                </div>
                <div>
                  <FeatherIcon icon="briefcase" size={19} />
                  <span>Gestion coordonnée des équipes, ressources et services administratifs.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Design3;
